import { pinFileToIPFSurl, pinJSONToIPFSurl, pinUpdateMetaUrl } from '../config/constants';
import { pinataAPIkey, pinataAPIsecret } from '../config/pinata.config';

const axios = require('axios');
const FormData = require('form-data');

const Exception = (type, message, e) => {
  return { type: type, message: message, error: e };
};

export const UploadArtToIPFS = async (nft, picture, thumbnailHash) => {
  //Create formData and add pic
  let data = new FormData();
  data.append('file', picture);

  //Metadata is in the form of a JSON object that's been converted to a string
  // Artwork
  const metadataForArtwork = JSON.stringify({
    name: nft.artworkName,
    keyvalues: {
      artistName: nft.artistName,
      price: nft.price,
      supplyNumber: nft.supplyNumber,
      description: nft.description,
      authorAddress: nft.address,
      thumbnailUrl: `https://${thumbnailHash}.ipfs.dweb.link`,
    },
  });

  const metadataForPDF = JSON.stringify({
    name: nft.artworkName,
    keyvalues: {
      artistName: nft.artistName,
      authorAddress: nft.address,
    },
  });

  thumbnailHash ? data.append('pinataMetadata', metadataForArtwork) : data.append('pinataMetadata', metadataForPDF);

  //pinataOptions
  const pinataOptions = JSON.stringify({
    cidVersion: 1,
  });
  data.append('pinataOptions', pinataOptions);
  try {
    return await axios.post(pinFileToIPFSurl, data, {
      maxBodyLength: 'Infinity', // needed to prevent axios from erroring out with large files
      headers: {
        'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
        pinata_api_key: pinataAPIkey,
        pinata_secret_api_key: pinataAPIsecret,
      },
    });
  } catch (error) {
    throw Exception('IPFS', thumbnailHash ? 'Artwork upload' : 'Pdf upload', error);
  }
};

export const UploadThumbToIPFS = async (nft, thumbnail) => {
  //Create formData and add pic
  let data = new FormData();
  data.append('file', thumbnail);

  const metadata = JSON.stringify({
    name: nft.artworkName,
    keyvalues: {
      artistName: nft.artistName,
      authorAddress: nft.address,
    },
  });
  data.append('pinataMetadata', metadata);
  //pinataOptions
  const pinataOptions = JSON.stringify({
    cidVersion: 1,
  });
  data.append('pinataOptions', pinataOptions);
    //'Access-Control-Allow-Origin': 'http://localhost:3000',
    try {
    return await axios.post(pinFileToIPFSurl, data, {
      maxBodyLength: 'Infinity', // needed to prevent axios from erroring out with large files
      headers: {
        'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
        pinata_api_key: pinataAPIkey,
        pinata_secret_api_key: pinataAPIsecret,
      },
    });
  } catch (error) {
    throw Exception('IPFS', 'Thumbnail upload', error);
  }
};

export const UploadJSONToIPFS = async (metadata) => {
  const jsonBody = {
    pinataOptions: {
      cidVersion: 1,
    },
    pinataMetadata: {
      name: metadata.name,
    },
    pinataContent: metadata,
  };
  return await axios.post(pinJSONToIPFSurl, jsonBody, {
    headers: {
      pinata_api_key: pinataAPIkey,
      pinata_secret_api_key: pinataAPIsecret,
    },
  });
};

/**
 * Upload files to IPFS
 * @param {Object} nft
 * @param {Object} picInfos
 * @param {Array} files
 * @returns
 */
export const UploadDirToIPFS = async (nft, picInfos, files) => {
  const data = new FormData();

  // Prepare multiple upload (pic, thumbnail, pdf)
  files.forEach((file) => {
    //for each file stream, we need to include the directory relative file path
    data.append(`file`, file, `${picInfos.picName}/${file.name}`);
  });

  //Metadata is in the form of a JSON object that's been converted to a string
  const metadata = JSON.stringify({
    name: picInfos.picName,
    keyvalues: {
      pictype: picInfos.picType,
      artworkName: nft.artworkName,
      artistName: nft.artistName,
      price: nft.price,
      supplyNumber: nft.supplyNumber,
      description: nft.description,
      address: nft.address,
    },
  });
  data.append('pinataMetadata', metadata);

  //pinataOptions
  const pinataOptions = JSON.stringify({
    cidVersion: 1,
  });
  data.append('pinataOptions', pinataOptions);

  try {
    const response = await axios.post(pinFileToIPFSurl, data, {
      maxBodyLength: 'Infinity', // needed to prevent axios from erroring out with large files
      headers: {
        'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
        pinata_api_key: pinataAPIkey,
        pinata_secret_api_key: pinataAPIsecret,
      },
    });
    return response;
  } catch (error) {
    throw error;
  }
};

/**
 * Update Pinata metadatas
 * @param {String} hash
 * @param {String} contractAddress
 * @returns
 */
export const UpdateMetaInIPFS = async (hash, contractAddress) => {
  const body = {
    ipfsPinHash: hash,
    keyvalues: {
      contractAddress: contractAddress,
    },
  };
  try {
    return await axios.put(pinUpdateMetaUrl, body, {
      headers: {
        pinata_api_key: pinataAPIkey,
        pinata_secret_api_key: pinataAPIsecret,
      },
    });
  } catch (error) {
    throw Exception('IPFS', 'Pinata Metadatas Update', error);
  }
};

/**
 * Unpin hash from IPFS
 * @param {String} hashToUnpin
 * @returns
 */
export const removePinFromIPFS = async (hashToUnpin) => {
  const url = `https://api.pinata.cloud/pinning/unpin/${hashToUnpin}`;
  try {
    return await axios.delete(url, {
      headers: {
        pinata_api_key: pinataAPIkey,
        pinata_secret_api_key: pinataAPIsecret,
      },
    });
  } catch (error) {
    throw Exception('IPFS', 'Remove Pin', error);
  }
};
